import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled, { css, CSSProp } from 'styled-components';
import { DocumentStatus } from 'types/documentsService';

interface DocumentCardStylings {
  $status: DocumentStatus;
}

export const CardStyled = styled.li<DocumentCardStylings>`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  box-shadow: ${boxShadows.light[4]};
  border: 1px solid ${colors.neutral[300]};
  list-style: none;
  position: relative;
  ${({ $status }): CSSProp => {
    switch ($status) {
      case DocumentStatus.REJECTED:
        return css`
          border-top: 1rem solid ${colors.red[600]};
        `;
      case DocumentStatus.APPROVED:
        return css`
          border-top: 1rem solid ${colors.green[600]};
        `;
      default:
        return css`
          border: 1px solid ${colors.neutral[300]};
        `;
    }
  }};
`;

export const CardTitleStyled = styled.h3`
  margin: 0;
  font-size: 2rem;
  line-height: 2.8rem;
  letter-spacing: 0.0225rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: ${colors.neutral[900]};
`;

export const CardHeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 3.2rem 1.5rem 3rem;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 3.2rem; /* Matches the padding value */
    right: 3.2rem; /* Matches the padding value */
    height: 1px; /* Thickness of the "border" */
    background-color: ${colors.neutral[300]};
  }
`;

export const CardBodyStyled = styled.div`
  padding: 1.5rem 3.2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const TopSectionStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
`;

export const InfoHeadingStyled = styled.h4`
  color: ${colors.neutral[500]};
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
`;

export const InfoDescriptionStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.025rem;
  color: ${colors.neutral[900]};
  margin: 0;
`;
